













import { Component, Mixins, Prop } from "vue-property-decorator";
import { MovableTextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { DisableableMixin } from "../../../system/mixins";
import MovableTextBoxObject from "../../../document/editor/objects/MovableTextBoxObject.vue";
import MovableTextBoxInputMethodSelector from "./MovableTextBoxInputMethodSelector.vue";
import InputMethodEditCheckBox from "./InputMethodEditCheckBox.vue";

@Component({
  components: {
    MovableTextBoxInputMethodSelector,
    InputMethodEditCheckBox,
  }
})
export default class MovableTextBoxInputMethodEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: MovableTextBoxObject;

  get selected(): MovableTextBoxInputMethodKinds {
    return this.source.inputMethodKind;
  }

  set selected(value: MovableTextBoxInputMethodKinds) {
    this.source.inputMethodKind = value;
  }
}
